<div class="confirm-modal-container">
  <ion-card class="profilebody ion-no-margin">
    <ion-row class="header-row">
      <h3>{{ CONSTANTS.HEADER }}</h3>
      <img [src]="IMAGES.CLOSE" alt="close" (click)="dialogRef.close()" />
    </ion-row>
    <div class="body">
      <div class="msg">{{ CONSTANTS.FOLLOWING_FILE }}</div>
      <div class="file-container">
        <ion-icon src="assets/csv-file.svg" class="csv-file-icon"></ion-icon>
        <p class="file-name">{{ file.fileItem?.name }}</p>
      </div>
    </div>
    <!-- footer -->
    <ion-row class="footer-row ion-justify-content-between">
      <ion-button fill="outline" class="cancel-btn" (click)="onClose('BACK')">{{
        CONSTANTS.BACK
      }}</ion-button>
      <ion-button fill="fill" class="submit-btn" (click)="onClose('CONFIRM')">{{
        CONSTANTS.CONFIRM
      }}</ion-button>
    </ion-row>
  </ion-card>
</div>
